// This file was auto-generated by Fern from our API Definition.
export var ChannelControls;
(function (ChannelControls) {
    ChannelControls.Indicator = {
        Message: "message",
        Native: "native",
    };
})(ChannelControls || (ChannelControls = {}));
